import React from "react";
import logo from "../assets/Alogo.png";
import websiteQR from "../assets/website-qr.png";

function InvoiceTemplate({
  invoice,
  billItems = [],
  subtotal = 0,
  discount = 0,
  totalCGST = 0,
  totalSGST = 0,
  grandTotal = 0,
  totalSavings = 0,
  onPrint,
  onSave,
  onClose,
  showSave = false,
}) {
  return (
    <div
      id="printable-receipt"
      className="invoice-content"
    >
      <img
        src={logo}
        alt="Logo"
        className="bill-logo"
      />

      <div className="bill-type">
        {(invoice?.paymentMethod || "Cash").toUpperCase()} BILL
      </div>

      <div className="company-name">
        ANUSHIKA AGRI PRODUCTS
      </div>

      <div className="company-address">
        <div>
          No.10, Ganesh Nagar,
          Kamarajar High Road
        </div>

        <div>
          Old Perungalathur,
          Chennai - 600063
        </div>

        <h4>Contact: 9551661177</h4>
      </div>

      <div className="company-gstin">
        GSTIN: 33BAWPB0037P1ZI
      </div>

      <div className="bill-details">
        <div>
          Bill no : {invoice?.invoiceNo}
        </div>

        <div className="date-time-row">
          <div>
            Date :
            {invoice?.createdAt?.seconds
              ? new Date(
                  invoice.createdAt.seconds * 1000
                ).toLocaleDateString("en-GB")
              : "-"}
          </div>

          <div>
            Time :
            {invoice?.createdAt?.seconds
              ? new Date(
                  invoice.createdAt.seconds * 1000
                ).toLocaleTimeString("en-IN")
              : "-"}
          </div>
        </div>

        <div>Cashier : admin</div>

        <div>
          Customer Name :
          {invoice?.customerName ||
            "Walk-in Customer"}
        </div>

        <div>
          Phone :
          {invoice?.customerPhone}
        </div>
      </div>

      <hr className="bill-line" />

      <div className="bill-table-header">
        <div style={{ width: "8%" }}>SL</div>
<div style={{ width: "34%" }}>ITEM NAME</div>
<div style={{ width: "17%" }}>QTY</div>
<div style={{ width: "15%" }}>MRP</div>
<div style={{ width: "12%" }}>RATE</div>
<div style={{ width: "14%", textAlign: "right" }}>AMT</div>
      </div>

      <hr className="bill-line" />

      {billItems.map((item, index) => (
        <div
          key={index}
          className="bill-item-row"
        >
          <div style={{ width: "8%" }}>
            {index + 1}
          </div>

          <div style={{ width: "55%" }}>
            {item.name}
          </div>

          <div style={{ width: "10%" }}>
            {item.qty}
          </div>

          <div style={{ width: "25%" }}>
            {item.mrpPrice || item.price}
          </div>

          <div style={{ width: "22%" }}>
            ₹
            {parseFloat(
              String(item.price || 0).replace(
                /[^\d.]/g,
                ""
              )
            )}
          </div>

          <div
            style={{
              width: "20%",
              textAlign: "right",
            }}
          >
            ₹
            {(
              parseFloat(
                String(item.price || 0).replace(
                  /[^\d.]/g,
                  ""
                )
              ) * Number(item.qty || 1)
            ).toFixed(0)}
          </div>
        </div>
      ))}

      <hr className="bill-line" />

      <div className="bill-summary-top">
        <div>
          Total Items :
          {billItems.length}
        </div>

        <div>
          Total Qty :
          {billItems.reduce(
            (sum, item) =>
              sum + Number(item.qty || 0),
            0
          )}
        </div>
      </div>

      <div className="bill-middle-section">
        <div className="bill-qr-section">
          <img
            src={websiteQR}
            alt="QR"
            className="website-qr"
          />
        </div>

        <div className="bill-totals">
          <div>
            <span>Sub Total</span>
            <span>:</span>
            <span>₹{subtotal}</span>
          </div>

          <div>
            <span>Discount</span>
            <span>:</span>
            <span>-₹{discount}</span>
          </div>

          <div>
            <span>CGST</span>
            <span>:</span>
            <span>
              ₹{totalCGST.toFixed(2)}
            </span>
          </div>

          <div>
            <span>SGST</span>
            <span>:</span>
            <span>
              ₹{totalSGST.toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      <div className="bill-line-top"></div>

      <div className="grand-total-row">
        <span>GRAND TOTAL</span>

        <span>
          ₹{grandTotal.toFixed(2)}
        </span>
      </div>

      <div className="bill-line-bottom"></div>

      <div className="payment-summary">
        <div>
          <span>Paid</span>

          <span>
            ₹{invoice?.paidAmount || 0}
          </span>
        </div>

        <div>
          <span>Change</span>

          <span>
            ₹{invoice?.changeAmount || 0}
          </span>
        </div>
      </div>

      <div className="savings-info">
        You Saved Rs : ₹
        {totalSavings.toFixed(2)}
      </div>

      <div className="bill-footer">
        <div>
          Thank you! Visit Again!
        </div>
      </div>

      <div className="bill-buttons">
        <button onClick={onPrint}>
          Print
        </button>

        {showSave && (
          <button onClick={onSave}>
            Save
          </button>
        )}

        <button onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default InvoiceTemplate;